import { render, staticRenderFns } from "./Telemetria.vue?vue&type=template&id=466e3280&scoped=true&"
import script from "./Telemetria.vue?vue&type=script&lang=ts&"
export * from "./Telemetria.vue?vue&type=script&lang=ts&"
import style0 from "./Telemetria.vue?vue&type=style&index=0&id=466e3280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466e3280",
  null
  
)

export default component.exports